import {useSelector} from "react-redux";
import {licenseSelector} from "../state/app/appSelectors";
import {hasAllFeatures, hasAnyFeature, hasFeature} from "../utils/featureAccess";

export const useHasFeature = featureKey => {
  const license = useSelector(licenseSelector);
  return hasFeature(license, featureKey);
};

export const useHasAnyFeature = featureKeys => {
  const license = useSelector(licenseSelector);
  return hasAnyFeature(license, featureKeys);
};

export const useHasAllFeatures = featureKeys => {
  const license = useSelector(licenseSelector);
  return hasAllFeatures(license, featureKeys);
};
